<template>
  <CommonLayout header="floristHeader" footer="floristFooter" ref="commonRef">
    <MeetingLayout :type="consts.meetingType.florist">
      <div class="base-color mh-550 shadow">
        <div class="p-2">
          <BOverlay :show="overlayShow" rounded="sm">
            <h5 class="text-dark-blue fw-bold pt-3">■お客様情報の入力内容のご確認</h5>
            <form @submit.prevent>
              <div class="px-4">
                <div class="mb-3 row">
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0">
                      <span class="fw-bold header-text-size">ご両家様名</span>
                    </div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input header-text-size" id="bothFamilyName">
                      {{ getBothFamilyName1 }}・{{ getBothFamilyName2 }}
                      <span class="ps-3" style="font-size:small">ご両家様</span>
                    </div>
                  </div>
                </div>
                <div class="mb-3 row">
                  <div class="col-sm-12 p-0">
                    <h5 class="fw-bold header-text-size">{{shinroShinpu1 !== 'shinro' ? '新婦様' : '新郎様'}}</h5>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 ps-3"><span>お名前</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break" id="groomName">{{getGroomLastName}} {{getGroomFirstName}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 ps-3"><span>お名前(カナ)</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="groomNameKana">{{getGroomLastNameKana}} {{getGroomFirstNameKana}}</div>
                  </div>
                  <div class="col-sm-12 row mt-1">
                    <div class="col-4 col-lg-3 p-0 ps-3"><span>電話番号</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break" id="groomPhoneNumber">{{getGroomPhoneNumber}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0"><span>メールアドレス</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break header-text-size" id="mailAddress">{{getMailAddress}}</div>
                  </div>
                </div>
                <div class="mb-3 row">
                  <div class="col-sm-12 p-0">
                    <h5 class="fw-bold header-text-size">{{shinroShinpu2 !== 'shinpu' ? '新郎様' : '新婦様'}}</h5>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 ps-3"><span>お名前</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break" id="brideName">{{getBrideLastName}} {{getBrideFirstName}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 ps-3"><span>お名前(カナ)</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="brideNameKana">{{getBrideLastNameKana}} {{getBrideFirstNameKana}}</div>
                  </div>
                  <div class="col-sm-12 row mt-1">
                    <div class="col-4 col-lg-3 p-0 ps-3"><span>電話番号</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break" id="bridePhoneNumber">{{getBridePhoneNumber}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0"><span>メールアドレス</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break header-text-size" id="brideMailAddress">{{getBrideMailAddress}}</div>
                  </div>
                </div>
              </div>
              <h5 class="header-bg-txt-color mt-5 mb-0 py-1">【個人情報のお取り扱いについて】</h5>
              <div class="col-sm-12 row px-0 mx-0">
                <div class="col-sm-12 overflow-auto border h-300" style="font-size:small">
                  <template v-for="(t, index) in consts.termsMsg.personalInformation" :key="`pi-${index}`">
                    <span>{{ t }}</span><br/>
                  </template>
                </div>

                <div class="col-sm-12 mb-3 mt-3 d-flex justify-content-center p-2">
                  <label
                    class="form-check-label labex-box-blue py-1 px-4"
                    for="personalInformationCheck"
                    :class="{ 'is-invalid': v$.personalInformationCheck.$error }"
                  >
                    <input
                      type="checkbox"
                      class="checkbox-scale-larger mt-2"
                      id="personalInformationCheck"
                      true-value="1"
                      false-value=""
                      v-model="personalInformationCheck"
                      @click="sendSignalingInputData"
                      :disabled="!isOperationPossible"
                    />
                    同意する
                  </label>
                </div>
                <div class="invalid-feedback d-block text-center">
                  {{ v$.personalInformationCheck.$error ? '同意が必要です' : '' }}
                </div>
              </div>

              <hr class="border-gray">

              <h5 class="header-bg-txt-color mt-5 mb-0 py-1">【画像の撮影・お取り扱いについて】</h5>
              <div class="col-sm-12 row px-0 mx-0">
                <div class="col-sm-12 overflow-auto border h-300" style="font-size:small">
                  <template v-for="(t, index) in consts.termsMsg.imageCheck" :key="`img-${index}`">
                    <span>{{ t }}</span><br/>
                  </template>
                </div>

                <div class="col-sm-12 mb-3 mt-3 d-flex justify-content-center p-2">
                  <label class="form-check-label labex-box-blue py-1 px-4 me-4" for="imageCheck">
                    <input
                      type="checkbox"
                      class="checkbox-scale-larger mt-2"
                      id="imageCheck"
                      true-value="1"
                      false-value=""
                      v-model="imageCheck"
                      @change="sendSignalingInputData"
                      :disabled="!isOperationPossible"
                    />
                    同意する
                  </label>

                  <label class="form-check-label labex-box py-1 px-4" for="imageCheckDisagree">
                    <input
                      type="checkbox"
                      class="checkbox-scale-larger mt-2"
                      id="imageCheckDisagree"
                      true-value="1"
                      false-value=""
                      v-model="imageCheckDisagree"
                      @change="sendSignalingInputData"
                      :disabled="!isOperationPossible"
                    />
                    同意しない
                  </label>
                </div>
              </div>

              <div class="col-sm-12 text-end mb-2 me-2">
                <BButton variant="outline-primary" class="w-25 sub-button-color back-button-disabled"
                  @click="backPage" :disabled="!isOperationPossible">戻る</BButton>

                <BButton
                  v-if="loginStatus && loginStatus.referenceFlag !== '1'"
                  variant="primary"
                  class="w-25 ms-3 main-button-color next-button-disabled"
                  @click="nextPage"
                  :disabled="!isOperationPossible"
                >送信</BButton>
              </div>
            </form>
          </BOverlay>
        </div>
      </div>
    </MeetingLayout>

    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<script>
import { computed, getCurrentInstance, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import MeetingLayout from '@/layout/MeetingLayout'

import fstore from '@/store/florist-store'
import mstore from '@/store/meeting-store'

import SignalingModel from '@/models/SignalingModel'
import CustomerRegistModel from '@/models/CustomerRegistModel'
import CommonLogModel from '@/models/CommonLogModel'

export default {
  name: 'FloristMeetingConfirm',
  components: { CommonLayout, MeetingLayout, CommonModal },

  setup () {
    const router = useRouter()
    const route = useRoute()
    const { proxy } = getCurrentInstance()

    const consts = proxy?.consts

    const commonRef = ref(null)
    const commonModal = ref(null)

    const overlayShow = ref(false)
    const personalInformationCheck = ref('')
    const imageCheck = ref('')
    const imageCheckDisagree = ref('')

    const loginStatus = ref(null)
    const isOperationPossible = ref(false)
    const shinroShinpu1 = ref('shinro')
    const shinroShinpu2 = ref('shinpu')

    // バリデーション（最低限：同意必須）
    const rules = computed(() => ({
      personalInformationCheck: { required }
    }))
    const v$ = useVuelidate(rules, { personalInformationCheck })

    // 表示用 computed
    const getBothFamilyName1 = computed(() => fstore.getters.bothFamilyName1)
    const getBothFamilyName2 = computed(() => fstore.getters.bothFamilyName2)
    const getGroomLastName = computed(() => fstore.getters.groomLastName)
    const getGroomFirstName = computed(() => fstore.getters.groomFirstName)
    const getGroomLastNameKana = computed(() => fstore.getters.groomLastNameKana)
    const getGroomFirstNameKana = computed(() => fstore.getters.groomFirstNameKana)
    const getGroomPhoneNumber = computed(() => fstore.getters.groomPhoneNumber)
    const getBrideLastName = computed(() => fstore.getters.brideLastName)
    const getBrideFirstName = computed(() => fstore.getters.brideFirstName)
    const getBrideLastNameKana = computed(() => fstore.getters.brideLastNameKana)
    const getBrideFirstNameKana = computed(() => fstore.getters.brideFirstNameKana)
    const getBridePhoneNumber = computed(() => fstore.getters.bridePhoneNumber)
    const getMailAddress = computed(() => fstore.getters.mailAddress)
    const getBrideMailAddress = computed(() => fstore.getters.brideMailAddress)

    const getIsTargetAtendeeActive = computed(() => mstore.getters.isTargetAtendeeActive)
    const getSignalingData = computed(() => fstore.getters.signalingReceiveData)
    const getIsOperationPossible = computed(() => fstore.getters.isOperationPossible)

    const toggleAgreeButton = (targetElm) => {
      if (targetElm.id === 'imageCheck') {
        imageCheckDisagree.value = targetElm.checked ? '' : '1'
        const el = document.getElementById('imageCheckDisagree')
        if (el) el.checked = !targetElm.checked
      } else {
        imageCheck.value = targetElm.checked ? '' : '1'
        const el = document.getElementById('imageCheck')
        if (el) el.checked = !targetElm.checked
      }
    }

    const sendSignalingInputData = (e) => {
      try {
        if (!isOperationPossible.value) return

        const clickedElmID = e?.target?.id ?? ''
        if (clickedElmID === 'imageCheck' || clickedElmID === 'imageCheckDisagree') {
          toggleAgreeButton(e.target)
        }

        const sendData = []
        const checkInputs = document.querySelectorAll('input[type="checkbox"]')
        for (let i = 0; i < checkInputs.length; i++) {
          sendData.push({ id: checkInputs[i].id, value: checkInputs[i].checked })
        }

        SignalingModel.sendInputEvent(proxy, sendData) // ★proxy必須
      } catch (err) {
        CommonLogModel.apiSetStore(null, {
          where: 'FloristMeetingConfirm.sendSignalingInputData',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
      }
    }

    const signalingNextPage = async (targetPath) => {
      try {
        const ok = await v$.value.$validate()
        if (!ok) return
        await router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(null, {
          where: 'FloristMeetingConfirm.signalingNextPage',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
      }
    }

    const signalingBackPage = async (targetPath) => {
      try {
        await router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(null, {
          where: 'FloristMeetingConfirm.signalingBackPage',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
      }
    }

    const nextPage = async () => {
      try {
        // ★cookieチェック（CommonLayoutのメソッドを呼ぶ）
        const okCookie = await commonRef.value?.cookieProjectNumberCheck?.()
        if (!okCookie) {
          await commonModal.value?.msgBoxOk(consts.errorMsg.otherCookieProjectNumber)
          return
        }

        const ok = await v$.value.$validate()
        if (!ok) return

        const imageFlag =
          imageCheck.value ? '01'
            : imageCheckDisagree.value ? '02'
              : '00'

        const params = {
          bothFamilyName1: fstore.getters.bothFamilyName1,
          bothFamilyName2: fstore.getters.bothFamilyName2,
          groomLastName: fstore.getters.groomLastName,
          groomFirstName: fstore.getters.groomFirstName,
          groomLastNameKana: fstore.getters.groomLastNameKana,
          groomFirstNameKana: fstore.getters.groomFirstNameKana,
          groomPhoneNumber: fstore.getters.groomPhoneNumber,
          brideLastName: fstore.getters.brideLastName,
          brideFirstName: fstore.getters.brideFirstName,
          brideLastNameKana: fstore.getters.brideLastNameKana,
          brideFirstNameKana: fstore.getters.brideFirstNameKana,
          bridePhoneNumber: fstore.getters.bridePhoneNumber,
          mailAddress: fstore.getters.mailAddress,
          brideMailAddress: fstore.getters.brideMailAddress,
          shinroShinpu1: fstore.getters.shinroShinpu1,
          shinroShinpu2: fstore.getters.shinroShinpu2,
          personalInformationFlag: personalInformationCheck.value ? '01' : '00',
          imageFlag
        }

        overlayShow.value = true
        const customerRegistModel = await CustomerRegistModel.apiSetStore(null, params, () => {
          overlayShow.value = false
        })
        overlayShow.value = false

        if (!customerRegistModel) {
          await commonModal.value?.msgBoxOk('お客様情報の更新に失敗しました')
          return
        }
        if (customerRegistModel.status !== 'success' || customerRegistModel.message) {
          await commonModal.value?.msgBoxOk(customerRegistModel.message)
          return
        }

        const targetPath = '/florist/meeting/send_mail'
        SignalingModel.sendClickEvent('next', proxy, { target_path: targetPath.replace('florist', 'customer') })
        await router.push(targetPath)
      } catch (err) {
        overlayShow.value = false
        CommonLogModel.apiSetStore(null, {
          where: 'FloristMeetingConfirm.nextPage',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
      }
    }

    const backPage = async () => {
      try {
        const okCookie = await commonRef.value?.cookieProjectNumberCheck?.()
        if (!okCookie) {
          await commonModal.value?.msgBoxOk(consts.errorMsg.otherCookieProjectNumber)
          return
        }
        const targetPath = '/florist/meeting/input'
        SignalingModel.sendClickEvent('back', proxy, { target_path: targetPath.replace('florist', 'customer') })
        await router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(null, {
          where: 'FloristMeetingConfirm.backPage',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
      }
    }

    // --- watch群 ---

    watch(getIsTargetAtendeeActive, (active) => {
      if (!active) return
      // 必須値チェック（元ロジック踏襲）
      if (!fstore.getters.bothFamilyName1 ||
          !fstore.getters.bothFamilyName2 ||
          !fstore.getters.groomLastName ||
          !fstore.getters.groomFirstName ||
          !fstore.getters.groomPhoneNumber ||
          !fstore.getters.brideLastName ||
          !fstore.getters.brideFirstName ||
          !fstore.getters.bridePhoneNumber ||
          !fstore.getters.mailAddress ||
          !fstore.getters.brideMailAddress) {
        fstore.commit('setErrorMsg', '値が不正です')
        backPage()
      }
    })

    watch(getSignalingData, (newData, oldData) => {
      try {
        if (!newData) return

        // ログ（$bvModalはnullでOK）
        CommonLogModel.apiSetStore(null, { ...newData, user: 'florist', timestampMs: Date.now() }, () => {})

        // ★current_path 同期：$route -> route
        if (newData.current_path && oldData) {
          const synchPath = newData.current_path.replace('customer', 'florist')
          if (synchPath !== route.path) {
            router.push(synchPath)
            return
          }
        }

        if (newData.event === 'click') {
          if (newData.id === 'next') signalingNextPage(newData.target_path)
          if (newData.id === 'back') signalingBackPage(newData.target_path)
        }

        if (!fstore.getters.isOperationPossible && newData.event === 'input') {
          for (let i = 0; i < newData.data.length; i++) {
            const d = newData.data[i]
            if (!d?.id) continue
            const elm = document.getElementById(d.id)
            if (!elm) continue

            if (elm.getAttribute('type') === 'checkbox') {
              elm.checked = d.value
              elm.value = d.value ? 1 : ''
              elm.dispatchEvent(new Event('change'))
            } else {
              elm.innerHTML = d.value
            }
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(null, {
          where: 'FloristMeetingConfirm.watch(getSignalingData)',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
      }
    }, { deep: true })

    watch(getIsOperationPossible, (bool) => {
      isOperationPossible.value = !!bool
    }, { immediate: true })

    onMounted(() => {
      // スクロール位置を一番上にする
      window.scrollTo(0, 0);
      isOperationPossible.value = fstore.getters.isOperationPossible
      fstore.commit('setIsOperationPossible', isOperationPossible.value)

      loginStatus.value = JSON.parse(localStorage.getItem('loginStatus') || 'null')

      shinroShinpu1.value = fstore.getters.shinroShinpu1
      shinroShinpu2.value = fstore.getters.shinroShinpu2
    })

    return {
      consts,
      commonRef,
      commonModal,

      overlayShow,
      personalInformationCheck,
      imageCheck,
      imageCheckDisagree,
      loginStatus,
      isOperationPossible,
      shinroShinpu1,
      shinroShinpu2,

      v$,

      getBothFamilyName1,
      getBothFamilyName2,
      getGroomLastName,
      getGroomFirstName,
      getGroomLastNameKana,
      getGroomFirstNameKana,
      getGroomPhoneNumber,
      getBrideLastName,
      getBrideFirstName,
      getBrideLastNameKana,
      getBrideFirstNameKana,
      getBridePhoneNumber,
      getMailAddress,
      getBrideMailAddress,

      sendSignalingInputData,
      nextPage,
      backPage
    }
  }
}
</script>
